export default "__VITE_ASSET__aK0nuXxZ__"